import React from 'react';
import { Helmet } from 'react-helmet-async';

function Application() {
  return (
    <div className="container" style={{ maxWidth: '800px' }}>
      <Helmet>
        <title>Application | Bunny Boutique 321</title>
        <meta name="description" content="Fill out your application today to get approved to take home one of our lovely bunnies." />
        <link rel="canonical" href="https://bunnyboutique321.com/application" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Application | Bunny Boutique 321" />
        <meta property="og:description" content="Fill out your application today to get approved to take home one of our lovely bunnies." />
        <meta property="og:url" content="https://bunnyboutique321.com/application" />
        <meta property="og:image" content="https://bunnyboutique321.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Application | Bunny Boutique 321" />
        <meta name="twitter:description" content="Fill out your application today to get approved to take home one of our lovely bunnies." />
        <meta name="twitter:image" content="https://bunnyboutique321.com/og-image.jpg" />
      </Helmet>
      <span className="eyebrow">Start Your Journey</span>
      <h1>Adoption Application</h1>
      <p className="section-subtitle">
        Ready to bring a new furry friend home? Please fill out our adoption application below to join the waitlist or request to reserve one of our available bunnies.
      </p>

      {/* Google Form Embed */}
      <div style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#ffffff',
        borderRadius: '20px',
        boxShadow: '0 4px 20px rgba(7,22,44,0.06)',
        overflow: 'hidden',
        paddingTop: '20px'
      }}>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSfe4qIY94VFLYHzqTidXd5Rf5VnD97nDsRXcinboOWh-_OIEQ/viewform?embedded=true"
          width="100%"
          height="1200" /* Height set to 1200 to accommodate form scrolling */
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="Bunny Boutique 321 Adoption Application"
        >
          Loading…
        </iframe>
      </div>
    </div>
  );
}

export default Application;